<template>
  <div class="lizard-form-bg">
    <div class="row lz-entry-row">
      <div class="col-lg-5 lz-entry-col">
        <ActivityForm :activityType="activityType" />
      </div>
      <div class="col-lg-7 lz-entry-col">
        <ActivityList />
      </div>
    </div>
  </div>
</template>

<style scoped>
.lizard-form-bg {
  background-color: #f8f9fa !important;
  border: 1px solid #eef0f2;
  border-radius: 12px;
  padding: 18px;
}
.lz-entry-row {
  margin-left: -9px;
  margin-right: -9px;
}
.lz-entry-col {
  padding-left: 9px;
  padding-right: 9px;
  margin-bottom: 18px;
}
@media (min-width: 992px) {
  .lz-entry-col {
    margin-bottom: 0;
  }
}
</style>

<script>
import ActivityForm from './ActivityForm'
import ActivityList from './ActivityList'

export default {
  name: 'ActivityEntry',
  props: ['activityType'],
  components: {
    ActivityForm,
    ActivityList
  },
  mounted() {
    this.$store.commit('resetFormData')
    this.$store.commit('clearActivityEnteries')
  }
}
</script>
